import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagingComponent } from './imaging.component';



@NgModule({
  declarations: [ImagingComponent],
  imports: [
    CommonModule
  ],
  exports:[ImagingComponent]
})
export class ImagingModule { }
